import { render, staticRenderFns } from "./Aoda.vue?vue&type=template&id=d687472a&scoped=true&"
import script from "./Aoda.vue?vue&type=script&lang=js&"
export * from "./Aoda.vue?vue&type=script&lang=js&"
import style0 from "./Aoda.vue?vue&type=style&index=0&id=d687472a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d687472a",
  null
  
)

export default component.exports